export default function SortArrowIcon(props) {
  return (
    <svg width={props.width || "10"} height={props.height || "12"} viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.56032 7.45237L5.75079 11.0714C5.56701 11.2463 5.33115 11.3333 5.09491 11.3333C4.85867 11.3333 4.62282 11.2463 4.43903 11.0714L0.629507 7.45237C0.248174 7.09001 0.232555 6.48735 0.594912 6.10566C0.957626 5.72618 1.56105 5.7098 1.94127 6.07142L4.14253 8.16237V1.61904C4.14253 1.09299 4.56886 0.666656 5.09491 0.666656C5.62096 0.666656 6.04729 1.09299 6.04729 1.61904V8.16237L8.24855 6.07142C8.62913 5.7098 9.23255 5.72544 9.59491 6.10566C9.95724 6.48735 9.94163 7.09001 9.56032 7.45237Z" fill={props.fill || "white"} />
    </svg>

  )
}
